export default new class {

    calculateScoreFromSets(set1, set2) {
        var score = {
            leftScore : 0,
            rightScore : 0,
            sets: []
          };
    
          set1.leftResult = parseInt(set1.leftResult, 10);
          set1.rightResult = parseInt(set1.rightResult, 10);
          set2.leftResult = parseInt(set2.leftResult, 10);
          set2.rightResult = parseInt(set2.rightResult, 10);
    
          if (set1.leftResult > set1.rightResult){
            score.leftScore = score.leftScore + 1;
          } else{
            score.rightScore = score.rightScore + 1;
          }
          if (set2.leftResult > set2.rightResult){
            score.leftScore = score.leftScore + 1;
          } else{
            score.rightScore = score.rightScore + 1;
          }
          score.sets.push(set1);
          score.sets.push(set2);
          return score;
    }
  
  }